<div class="sac-begin-umbrueckung-dialog">

  <div class="dialog-layout">
    <sc-dialog-title>
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.sac-begin-umbrueckung-dialog.title"></sc-dictionary-label>
    </sc-dialog-title>

    <div class="top-info">
      <app-transport-info-panel [carrier]="details.carrier" [identifier]="details.identifier" [driver]="details.name"
      [scope]="details.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content no-field-space">

      <sc-sub-title>
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.sac-begin-umbrueckung-dialog.remaining-transport-details.title"></sc-dictionary-label>
      </sc-sub-title>
      <sc-content-spacer vertical></sc-content-spacer>
      @if (umbrueckungPossible) {
        <div>
          <mat-form-field class="width-250" [hidden]="!isTrailerNumberVisible()" appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.firstLoadCarrier.trailerNumberPlate"></sc-dictionary-label>
            </mat-label>
            <input name="trailerNumberPlate" matInput [(ngModel)]="details.trailerNumberPlate"
              [required]="isTrailerNumberPlateRequired()" [maxlength]="255">
            </mat-form-field>
          </div>
          @if (isSwapTrailerEnabled()) {
            <div>
              <sc-content-spacer vertical></sc-content-spacer>
              <mat-form-field class="width-250" appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.firstLoadCarrier.swapTrailerNumber"></sc-dictionary-label>
                </mat-label>
                <input name="swapTrailerNumber" matInput [(ngModel)]="details.swapTrailerNumber"
                  [required]="isSwapTrailerNumberRequired()" [maxlength]="255">
                </mat-form-field>
              </div>
            }
          }

          <div class="messages">
            <app-service-response [responseMessages]="responseMessages"></app-service-response>
          </div>
        </div>

        <sc-padding>
          <sc-flex>
            <sc-content-spacer grow></sc-content-spacer>
            <button mat-stroked-button class="cancel-button" (click)="closeDialog()"
              [disabled]="isCloseDialogDisabled()">
              <sc-dictionary-label dictionaryKey="tmc-yard.common.action.cancel"></sc-dictionary-label>
            </button>
            <sc-content-spacer></sc-content-spacer>
            <sc-button class="confirm-button" primary (click)="beginUmbrueckung()" [disabled]="isBeginUmbrueckungDisabled()"
              dictionaryKey="tmc-yard.ui.control.sac-client.sac-begin-umbrueckung-dialog.action.begin">
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.sac-begin-umbrueckung-dialog.action.begin"></sc-dictionary-label>
            </sc-button>
          </sc-flex>
        </sc-padding>


      </div>
    </div>
